import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateWorkshopCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (!improvementsForTransaction || !identification) return undefined;

  const { workshop } = improvementsForTransaction;
  const {
    address: { PostalCode: zipCode },
  } = identification;

  if (!workshop || !workshop.area || isUndefined(workshop.quality) || isUndefined(zipCode)) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  return calculator.getWorkshopCost({
    hasFeature: ORDER_FEATURES.workshop.hasFeature(improvementsForTransaction),
    sqft: AloftArea.schema.parse(workshop.area),
    quality: workshop.quality,
    zipCode,
  });
};

export const {
  selectWorkshopCost,
  selectZipOnlyWorkshopCost,
  selectWorkshopCosts,
  selectWorkshopCostDisplay,
} = createFeatureCostSelectors({
  calculate: calculateWorkshopCost,
  inputSelectors: [
    selectCostProps,
    selectImprovementsEntities,
    selectPropertyIdentificationEntities,
  ],
  names: {
    cost: 'selectWorkshopCost',
    zipOnly: 'selectZipOnlyWorkshopCost',
    costs: 'selectWorkshopCosts',
    display: 'selectWorkshopCostDisplay',
  },
});
